export default __webpack_public_path__ + "static/media/wow awards.a387d60c.jpeg";